<div class="main">
  <div class="logo">
    <img src="Watermark.png" alt="Logo" />
  </div>
 
  <div class="col-sm-6 leftimages">
    <img src="swarajlogo.png" alt="Logo" />
  </div>
 
  <div class="col-sm-6 loginsection">
    <div class="loginSection">
      <div class="creditLimit">Credit Limit <em>Management System</em> </div>
      <mat-card class="card">
        <mat-card-header>
          <mat-card-title class="heading">Login</mat-card-title>
          <mat-card-subtitle class="subheading">
            Please enter your login details
          </mat-card-subtitle>
        </mat-card-header>
 
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <mat-label class="custom-label">Username</mat-label>
          <div class="form-field">
            <mat-icon class="email">email</mat-icon>
            <input  matinput placeholder="Username" formControlName="username" autocomplete="off" required />
          </div>
 
          <mat-label class="custom-label">Password</mat-label>
          <div class="form-field">
            <mat-icon class="password-lock">lock</mat-icon>
            <input  [type]="hide ? 'password' : 'text'" placeholder="Password" formControlName="password"
              autocomplete="off" required />
            <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide" class="passwordToogle">
              <mat-icon class="toggle-visibility">{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
 
            </button>
          </div>
 
       
           
            <div class="recaptcha">
              <mat-label class="custom-label">Security Text</mat-label>
              <div class="belowitems">
                <div class="captcha">
 
 
                  <div _ngcontent-ng-c2592074317="" class="leftbox">
                    <input _ngcontent-ng-c2592074317="" matinput="" placeholder="Enter the shown text"
                      formControlName="captchaInp" autocomplete="off" required="" ng-reflect-required=""
                      ng-reflect-name="username" class="ng-pristine ng-invalid ng-touched" />
                  </div>
 
                  <div class="captcha-text">
                    <span>{{ captcha }}</span>
                  </div>
 
                  <mat-icon class="reload" (click)="generateCaptcha()" style="margin-top: 3%; cursor: pointer; margin-right: 14px;">cached</mat-icon>

                </div>
              </div>
            </div>
 
          <div class="form-field-button">
            <button mat-raised-button>Login</button>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
 
  <div class="footer">
    <p>© 2025 Swaraj. All rights reserved.</p>
  </div>
</div>
 

  <!-- <div class="main">
    <div class="logo">
      <img src="Watermark.png" alt="Logo" />
    </div>
   
    <div class="col-sm-6 leftimages">
      <img src="swarajlogo.png" alt="Logo" />
    </div>
   
    <div class="col-sm-6 loginsection">
      <div class="loginSection">
        <div class="creditLimit">Credit Limit <em>Management System</em> </div>
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title class="heading">Login</mat-card-title>
            <mat-card-subtitle class="subheading">
              Please enter your login details
            </mat-card-subtitle>
          </mat-card-header>
   
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <mat-label class="custom-label">Username</mat-label>
            <div class="form-field">
              <mat-icon class="email">email</mat-icon>
              <input  matinput placeholder="Username" formControlName="username" autocomplete="off" required />
            </div>
   
            <mat-label class="custom-label">Password</mat-label>
            <div class="form-field">
              <mat-icon class="password-lock">lock</mat-icon>
              <input  [type]="hide ? 'password' : 'text'" placeholder="Password" formControlName="password"
                autocomplete="off" required />
              <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide" class="passwordToogle">
                <mat-icon class="toggle-visibility">{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
   
              </button>
            </div>
   
         
              <div >
                  <div
                  id="your-recaptcha-container-id"
                  class="g-recaptcha captcha"
                  style="margin-left: -3px;margin-bottom: 80px;"
                ></div>
   
             
              </div>
            
   
            <div class="form-field-button">
              <button mat-raised-button>Login</button>
            </div>
          </form>
        </mat-card>
      </div>
    </div>
   
    <div class="footer">
      <p>© 2025 Swaraj. All rights reserved.</p>
    </div>
  </div>
   
    -->